<template>
  <ElConfigProvider :locale="DE">
    <NuxtPage></NuxtPage>
  </ElConfigProvider>
</template>
<script lang="ts" setup>
import DE from "element-plus/dist/locale/de.min.mjs";

import { handleFileDownload } from "~/modules/common/services/util/util";
import { ApplicationScope } from '~/api-client';

const { $backendService, $logger } = useNuxtApp();

// Body-Klasse synchron beim Layout-Mount setzen, NICHT erst nach dem Page-
// useAsyncData. Sonst greift Bootstraps globaler `body { background-color:
// var(--bs-body-bg) }` (= #242b33 vom Black-Dashboard-Theme) und der
// Bildschirm wirkt während des Datenbank-Ladens schwarz. Mit der Klasse
// gilt sofort `background-color: var(--db-body-background-color, transparent)`
// → Canvas (Browser-Default ≈ weiß) scheint durch.
useHead({
  bodyAttrs: {
    class: 'db-view-body',
  },
});

const showLoginDialog = ref(false);

const downloadTerms = () => {
  $backendService.termsConditionsControllerApi.getCurrentTermsAndConditions({
    xApplicationScope: ApplicationScope.MyDb
  }).then(response => {
    handleFileDownload(response, 'agb.pdf');
  }).catch(error => {
    $logger.error('unable to download terms', error);
    ElMessage.error("Beim Herunterladen ist ein Fehler aufgetreten");
  });
};

const toggleLoginModal = () => showLoginDialog.value = !showLoginDialog.value;

</script>
<style lang="scss">
.navbar.auth-navbar {
  top: 0;
}

@media (max-width: 600px) {
  .logo-mobile {
    margin-right: -25px !important;
  }
}
</style>
